import { useMemo } from "react";

const data = {
    "tasks": [
        {
            "id": "t-101",
            "title": "Inicjał zdrowia",
            "mapNumber": "1"
        },
        {
            "id": "t-102",
            "title": "Zdrowe nawyki",
            "requires": "t-101",
            "mapNumber": "2"
        },
        {
            "id": "t-103",
            "title": "Prawda czy fałsz?",
            "requires": "t-102",
            "mapNumber": "3"
        },
        {
            "id": "t-104",
            "title": "Czytanie wzmacnia",
            "requires": "t-103",
            "mapNumber": "4"
        },
        {
            "id": "t-105",
            "title": "Trenuj lekturę!",
            "requires": "t-104",
            "mapNumber": "5"
        },
        {
            "id": "t-106",
            "title": "Szlachetne zdrowie...",
            "requires": "t-105",
            "mapNumber": "6"
        },


        {
            "id": "t-201",
            "title": "Wywiad czytelniczy",
            "mapNumber": "1"
        },
        {
            "id": "t-202",
            "title": "Międzynarodowy Tydzień Pisania Listów",
            "requires": "t-201",
            "mapNumber": "2"
        },
        {
            "id": "t-203",
            "title": "Czytanie wzmacnia głos!",
            "requires": "t-202",
            "mapNumber": "3"
        },
        {
            "id": "t-204",
            "title": "Podejmij decyzje",
            "requires": "t-203",
            "mapNumber": "4"
        },
        {
            "id": "t-205",
            "title": "Czytanie wzmacnia odporność na głupotę",
            "requires": "t-204",
            "mapNumber": "5"
        },
        {
            "id": "t-206",
            "title": "Podróż dookoła świata",
            "requires": "t-205",
            "mapNumber": "6"
        },



        {
            "id": "t-401",
            "title": "Pudełko zwane wyobraźnią",
            "mapNumber": "1"
        },
        {
            "id": "t-402",
            "title": "Lemowe Bajki",
            "requires": "t-401",
            "mapNumber": "2"
        },
        {
            "id": "t-403",
            "title": "Nietypowe zastosowanie",
            "requires": "t-402",
            "mapNumber": "3"
        },
        {
            "id": "t-404",
            "title": "Rusz głową!",
            "requires": "t-403",
            "mapNumber": "4"
        },
        {
            "id": "t-405",
            "title": "Różowe okulary",
            "requires": "t-404",
            "mapNumber": "5"
        },
        {
            "id": "t-406",
            "title": "Tuba z Kosmosu",
            "requires": "t-405",
            "mapNumber": "6"
        },




        {
            "id": "t-301",
            "title": "Podróż w przeszłość",
            "mapNumber": "1"
        },
        {
            "id": "t-302",
            "title": "Patroni roku",
            "requires": "t-301",
            "mapNumber": "2"
        },
        {
            "id": "t-303",
            "title": "Detektywistyczna robota",
            "requires": "t-302",
            "mapNumber": "3"
        },
        {
            "id": "t-304",
            "title": "Poznajemy świat",
            "requires": "t-303",
            "mapNumber": "4"
        },
        {
            "id": "t-305",
            "title": "A to co?",
            "requires": "t-304",
            "mapNumber": "5"
        },
        {
            "id": "t-306",
            "title": "Wspomnień czar",
            "requires": "t-305",
            "mapNumber": "6"
        }
    ]
}

export default function useGame() {


    const tasks = useMemo(() => data?.tasks || [], []);

    const taskIds = useMemo(() => {
        return tasks.map(t => t.id);
    }, [tasks])


    return {
        isLoading: false,
        tasks,
        taskIds
    }
}
